var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tbody',{class:_vm.theme},[_c('tr',[_c('td',{attrs:{"colspan":_vm.colspan}},[_vm._t("default",function(){return [_c('OurEmptyBlock',{staticClass:"empty-table-msg",attrs:{"description":_vm.emptyTableMsg,"size":"sm","data-cy":"empty-table-msg"}})]})],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }